import PropTypes from 'prop-types';

export const getShimmerStyles = () => {
  const shimmerContainer = {
    padding: '15px 0',
    root: { margin: '5px' },
    '& .height-15 .ms-Shimmer-shimmerWrapper': {
      height: '15px',
    },
    '& .height-22 .ms-Shimmer-shimmerWrapper': {
      height: '22px',
    },
    '& .height-33 .ms-Shimmer-shimmerWrapper': {
      height: '33px',
    },
    '& .height-40 .ms-Shimmer-shimmerWrapper': {
      height: '40px',
    },
  };

  return {
    shimmerContainer,
  };
};

export const classesProps = PropTypes.shape({
  shimmerContainer: PropTypes.string,
});
